import { render, staticRenderFns } from "./LocalOrders.vue?vue&type=template&id=beddbc08"
import script from "./LocalOrders.vue?vue&type=script&lang=js"
export * from "./LocalOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports